import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { Data } from 'signup-constants/signupData/Data';
import { getSignupDataGtkmData, getSignupDataValue } from '../store/signup-data/selectors';
import { hasEndpointBeenFetched } from '../store/http-responses/selectors';
import { isAssignedToGTKMExperiment } from '../utils/gtkm/isAssignedToGTKM';
export const shouldOnlyFetchGTKMData = (state, endpointKey) => {
  const isInGTKMExperiment = isAssignedToGTKMExperiment(state);
  if (isInGTKMExperiment) {
    return false;
  }
  const hasFetchedGTKMData = hasEndpointBeenFetched(state, endpointKey);
  if (hasFetchedGTKMData) {
    return false;
  }
  const activeFlows = [Flow.Crm, Flow.Sales, Flow.Marketing, Flow.Service];
  return activeFlows.includes(getFlowKey());
};
export const hasGTKMDomainChanged = state => {
  const companyDomain = getSignupDataValue(state, Data.CompanyDomain);
  const gtkmCompanyDomain = getSignupDataGtkmData(state, Data.CompanyDomain);
  return companyDomain && companyDomain !== gtkmCompanyDomain;
};